const CACHE_PREFIX = 'memberNest.offlineContent';
const CACHE_VERSION = 1;

function getStorage() {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage || null;
  } catch (err) {
    return null;
  }
}

function normalizePart(value) {
  return encodeURIComponent(String(value || '').trim());
}

export function getOfflineContentCacheKey(parts = []) {
  return [
    CACHE_PREFIX,
    `v${CACHE_VERSION}`,
    ...parts.map(normalizePart),
  ].join(':');
}

function encodeValue(value) {
  if (!value || typeof value !== 'object') return value;
  if (typeof value.toMillis === 'function') {
    return {
      __memberNestTimestamp: true,
      millis: value.toMillis(),
    };
  }
  if (value instanceof Date) {
    return {
      __memberNestDate: true,
      iso: value.toISOString(),
    };
  }
  if (Array.isArray(value)) return value.map(encodeValue);
  return Object.entries(value).reduce((acc, [key, entry]) => {
    acc[key] = encodeValue(entry);
    return acc;
  }, {});
}

function decodeValue(value) {
  if (!value || typeof value !== 'object') return value;
  if (value.__memberNestTimestamp) {
    const millis = Number(value.millis || 0);
    return {
      toMillis: () => millis,
      toDate: () => new Date(millis),
    };
  }
  if (value.__memberNestDate) {
    return new Date(value.iso);
  }
  if (Array.isArray(value)) return value.map(decodeValue);
  return Object.entries(value).reduce((acc, [key, entry]) => {
    acc[key] = decodeValue(entry);
    return acc;
  }, {});
}

export function readOfflineContentCache(parts, fallback = null) {
  const storage = getStorage();
  if (!storage) return fallback;
  try {
    const raw = storage.getItem(getOfflineContentCacheKey(parts));
    if (!raw) return fallback;
    const parsed = JSON.parse(raw);
    if (parsed?.version !== CACHE_VERSION) return fallback;
    return decodeValue(parsed.value);
  } catch (err) {
    return fallback;
  }
}

export function writeOfflineContentCache(parts, value) {
  const storage = getStorage();
  if (!storage) return false;
  try {
    storage.setItem(getOfflineContentCacheKey(parts), JSON.stringify({
      version: CACHE_VERSION,
      savedAt: new Date().toISOString(),
      value: encodeValue(value),
    }));
    return true;
  } catch (err) {
    return false;
  }
}

export function removeOfflineContentCache(parts) {
  const storage = getStorage();
  if (!storage) return;
  try {
    storage.removeItem(getOfflineContentCacheKey(parts));
  } catch (err) {}
}
